<template>
  <card>
    <list
      v-if="$store.state.user.is_root"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "tariff",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "type",
          label: "Тип",
          type: "static_radio",
          items: [
            { id: "month", title: "По месяцам" },
            { id: "count", title: "По урокам" },
          ],
        },
        {
          key: "title",
          label: "Название",
          isMultiLang: true,
          type: "field",
        },
        {
          key: "description",
          label: "Краткое описание",
          isMultiLang: true,
          type: "textarea",
        },
        {
          key: "period",
          label: "Количество",
          type: "field",
          textType: "number",
        },
        {
          key: "price",
          label: "Стоимость",
          type: "field",
          textType: "number",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_tariff",
      itemLink: "tariffs",
      setLink: "tariffs",
      columns: [
        {
          key: "title",
          title: "Название",
        },
        {
          key: "is_active",
          title: "Активность",
        },
        {
          key: "price",
          title: "Стоимость",
        },
        {
          key: "period",
          title: "Период (мес.)",
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
